import React from 'react';
const TextInputOnRow = ({
  placeholder = '',
  value = '',
  inputProps = {},
  disabled = '',
  labelClass = 'label-control',
  inputClass = 'form-control input-sm',
  wrapperClass = 'form-group',
  labelText = '',
  starRed = '',
  error,
}) => {
  return (
    <div className={wrapperClass}>
      <label className={labelClass}>
        {labelText}{' '}
        <span
          className="canh-bao-red"
          style={{ margin: '-5px 0 0 0', display: 'inline-block' }}
        >
          {starRed}
        </span>
      </label>
      <input
        type="text"
        className={inputClass}
        disabled={disabled}
        value={value}
        placeholder={placeholder}
        {...inputProps}
      />
      {error && <span className="canh-bao-red">{error.message}</span>}
    </div>
  );
};
export default TextInputOnRow;
